var map = {
	"./en/common.json": 79802,
	"./en/dbp.json": 6443,
	"./en/dsr-license.json": 3022,
	"./en/dsr-unified.json": 71639,
	"./en/dsr.json": 56932,
	"./en/enums.json": 78111,
	"./en/esg.json": 34088,
	"./it/common.json": 11140,
	"./it/dbp.json": 11421,
	"./it/dsr-license.json": 48992,
	"./it/dsr-unified.json": 73773,
	"./it/dsr.json": 69362,
	"./it/enums.json": 57589,
	"./it/esg.json": 7606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89628;